import { useLang } from 'hooks/lang';

import { loaders } from 'entities';
import { useRouteParams } from 'routes';

import { ResponsiveOverlay } from 'components/Blocks';
import { Logs } from 'components/Logs';

interface LogsModalProps {
  isOpen: boolean;
  close: () => void;
}

export function InvoiceLogsModal({ close, isOpen }: LogsModalProps) {
  const { t } = useLang();

  const { projectId } = useRouteParams('projectProfile');

  const { data, error, loading } = loaders.invoice.invoiceControlEvents.use({
    defaultValue: [],

    params: { projectId },

    blockLoad: !isOpen,
  });

  return (
    <ResponsiveOverlay
      title={t('logs')}
      width="min(80vw, 860px)"
      close={close}
      isOpen={isOpen}
      className="overflow-y-auto"
      allowEscape
    >
      <Logs loading={loading || error} logs={data} />
    </ResponsiveOverlay>
  );
}
